export default {
  LIST_FETCHED: 'ABOUT_FETCHED',
  LIST_LOAD: 'ABOUT_LOAD',
  ITEM_DETAIL: 'ABOUT_DETAIL',
  BUTTON_LOAD: 'ABOUT_BUTTON_LOAD',
};
